import { useContext, useEffect } from "react";
import { MIContext } from "../MIContext";
import DataService from "../../../../../../Service";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";

const useFetchMI = () => {
  const {
    service,
    serviceType,
    organisationID,
    page,
    tableSearch,
    setTotalCount,
    setAssignmentData,
    setTableLoader,
    statisticsFilter,
    pageSize,
    dateFilter,
    assignmentData,
  } = useContext(MIContext);

  const globaluserData = useSelector((state) => state.commonReducer);
  const orgID = globaluserData.organisation_id;
  let role = globaluserData.role;
  const dispatch = useDispatch();

  const fetchAssignmentsFunc = () => {
    const params = {
      page: page + 1,
      count_per_page: pageSize,
      search_keyword: tableSearch?.searchText,
      from_date_filter: dateFilter?.startDate,
      to_date_filter: dateFilter?.endDate,
    };

    if (serviceType && serviceType !== "all") {
      params.service = serviceType;
    }
    if (service && service !== "all") {
      params.service_type = service;
    }
    if (statisticsFilter && statisticsFilter !== "All") {
      params.main_filter = statisticsFilter;
    }
    if (
      tableSearch.searchCategory &&
      tableSearch.searchCategory.value !== "all"
    ) {
      params.filter_type = tableSearch.searchCategory.value;
    }

    if (role === "admin") {
      if (organisationID && organisationID !== "all") {
        params.organisation_id = organisationID;
      }
    }

    if (role === "employee") {
      params.organisation_id = orgID;
    }

    const finalParams = {};

    for (let key in params) {
      if (params[key] !== undefined) {
        if (!(params[key] === "undefined")) {
          finalParams[key] = params[key];
        }
      }
    }

    let url = "/assignments";
    if (!(role === "admin")) {
      url += "/list_org_assignments";
    }
    return DataService.getDirectData(url, finalParams);
  };

  const {
    data,
    isLoading,
    isRefetching: isRefetchingMiTable,
    isError,
    refetch: refetchMITable,
  } = useQuery(
    [
      "MI",
      statisticsFilter,
      organisationID || orgID,
      service,
      serviceType,
      page + 1,
      pageSize,
    ],
    fetchAssignmentsFunc,
    {
      staleTime: 840000,
      cacheTime: 900000,
      refetchOnWindowFocus: false,
      refetchInterval: 840000,
      onSuccess: (data) => {
        if (data?.assignments) {
          setTotalCount(data?.total_count);
          setAssignmentData(data?.assignments);
          setTableLoader(false);
        }
      },
      onError: () => {
        dispatch(showSnackbar("error", ["something went wrong"], 10000));
      },
    }
  );

  useEffect(() => {
    setTableLoader(true);
    refetchMITable();
  }, [page, tableSearch.searchText, dateFilter, pageSize]);

  useEffect(() => {
    setTableLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (data && assignmentData.length === 0) {
      setAssignmentData(data?.assignments);
      setTotalCount(data?.total_count);
    }
  }, [data]);

  return { refetchMITable, isRefetchingMiTable, isLoading };
};

export default useFetchMI;
